import {faAngleLeft, faAngleRight} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button} from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import {SyntheticEvent} from 'react';

import {Text} from '../../../../../../../../../component/text/text';
import {Locale} from '../../../../../../../../../provider/locale/localization';
import {PostAiGeneratedImageType} from '../../../../../../../../../service/posts/posts-types';

import {GenerationImageCard} from './generation-image-card';
import * as styles from './generation-result-step.scss';

type PropsType = {
    activeSuggestIndex: number;
    totalSuggests: number;
    onChangeActiveSuggestIndex: (index: number) => void;
    text: string;
    onEditText: (text: string) => void;
    image: PostAiGeneratedImageType | null;
    imageEnabled: boolean;
    isRegeneratingImage: boolean;
    isSlowImageGeneration: boolean;
    onRegenerateImage: () => void;
    onDeleteImage: () => void;
};

export function GenerationResultStep(props: PropsType): JSX.Element {
    const {
        activeSuggestIndex,
        totalSuggests,
        onChangeActiveSuggestIndex,
        text,
        onEditText,
        image,
        imageEnabled,
        isRegeneratingImage,
        isSlowImageGeneration,
        onRegenerateImage,
        onDeleteImage,
    } = props;

    const isLastSuggestActive = activeSuggestIndex === totalSuggests - 1;

    return (
        <div className={styles.GenerationResultStep}>
            {totalSuggests > 1 && (
                <div className={styles.GenerationResultStep_header}>
                    <Text bolder lighter>
                        <Locale
                            stringKey="POSTS_SUGGESTS__SUGGEST"
                            valueMap={{current: activeSuggestIndex + 1, total: totalSuggests}}
                        />
                    </Text>

                    <div className={styles.GenerationResultStep_navigation}>
                        <Button
                            className={styles.GenerationResultStep_navigationButton}
                            disabled={activeSuggestIndex === 0}
                            onClick={() => onChangeActiveSuggestIndex(activeSuggestIndex - 1)}
                        >
                            <FontAwesomeIcon icon={faAngleLeft} />
                        </Button>
                        <Button
                            className={styles.GenerationResultStep_navigationButton}
                            disabled={isLastSuggestActive}
                            onClick={() => onChangeActiveSuggestIndex(activeSuggestIndex + 1)}
                        >
                            <FontAwesomeIcon icon={faAngleRight} />
                        </Button>
                    </div>
                </div>
            )}

            <div className={styles.GenerationResultStep_content}>
                {imageEnabled && (
                    <GenerationImageCard
                        image={image}
                        isRegenerating={isRegeneratingImage}
                        isSlowGeneration={isSlowImageGeneration}
                        onDelete={onDeleteImage}
                        onRegenerate={onRegenerateImage}
                    />
                )}

                <div className={styles.GenerationResultStep_textBlock}>
                    <TextArea
                        className={styles.GenerationResultStep_textArea}
                        onChange={(event: SyntheticEvent<HTMLTextAreaElement>) => onEditText(event.currentTarget.value)}
                        value={text}
                    />
                </div>
            </div>
        </div>
    );
}
